import React from 'react';
import { $SvgIcon } from './styles';
import { theme } from '../newTheme';
export const ExpandIcon = ({ expanded, secondary }) => expanded ? React.createElement($SvgIcon, { name: 'chevron-up', color: secondary ? theme.colors.secondary : '#757778', size: 20 }) : React.createElement($SvgIcon, { name: 'chevron-down', color: secondary ? theme.colors.secondary : '#757778', size: 20 });
